import Form from '../../../forms/Form'

interface EndDateFieldProps {
  fields: Record<string, any>
  formId: string
}

/**
 * @description Renders EndDateField for the Add Medication modal
 * @param {EndDateFieldProps} props - The component's props.
 * @returns {JSX.Element} EndDateField.
 */
export default function EndDateField(props: EndDateFieldProps): JSX.Element {
  const { fields, formId } = props

  return (
    <Form
      noLeftMargin
      formId={formId}
      fields={fields}
      form={END_DATE_FORM}
      required
    />
  )
}

const END_DATE_FORM = [
  {
    description:
      'If this medication has an end date, it will automatically be taken off the Carer App and Care Office on this date.',
    hasComment: true,
    key: 'hasEndDate',
    label: 'End',
    optionType: 'boolean',
    type: 'radio-group',
    values: [
      {
        label: 'No - Ongoing',
        value: false,
      },
      {
        label: 'Yes - On specific date',
        value: true,
      },
    ],
  },
  {
    formFieldStyle: { minWidth: 115, maxWidth: 115 },
    dependsOnKey: 'hasEndDate',
    dependsOnValue: true,
    displayCalendar: true,
    key: 'endDate',
    label: 'End date',
    placeholder: 'DD-MM-YYYY',
    style: { marginRight: 0, marginTop: 0 },
    type: 'date',
    validationTypes: [
      'validDate',
      { typeKey: 'endDate', relatedKeys: ['startDate'] },
    ],
  },
]
